export default "__VITE_ASSET__CYhtk$ji__"